// ##### 24-06-13 Komarov
import React from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
// ##### 25-05-21 Komarov
import AvailableNowSign from '../../../../Library/Icons/availableNowSign';
import OnRequestSign from '../../../../Library/Icons/onRequestSign';

// ##### 24-05-22 Komarov: компонент с элементом для отображения условных обозначений точек на иконках в элементах Autocomplete
// ##### Komarov 2025-07-21
const HotelsCitiesAvailabilityHint = ({ hotelsCitiesAvailabilityHintRef, switcherRef }) => {
  // ##### Komarov 2025-08-05
  const availableNow = useLocalizedText('Available_Now');
  const onRequest = useLocalizedText('Available_OnRequest');
  if (!switcherRef?.current) return null;

  return createPortal(
    <div
      data-component="HotelsCitiesAvailabilityHint"
      className="hotels-cities-availability-hint"
      ref={hotelsCitiesAvailabilityHintRef}
    >
      <div style={{ display: 'flex' }}>
        <AvailableNowSign /> &nbsp; {availableNow}
      </div>
      <div style={{ display: 'flex' }}>
        <OnRequestSign /> &nbsp; {onRequest}
      </div>
    </div>,
    switcherRef.current
  );
};

export default HotelsCitiesAvailabilityHint;
